export const shouldForwardProp = (prop: string) => {
  // 定义哪些属性应该被传递
  const forbiddenProps = ["mixin"];
  return !forbiddenProps.includes(prop);
};
